module.exports = __webpack_public_path__ + "static/img/tranfer.dc4f557d.svg";